import {auth} from './firebase';

// Bind token acquisition, dispatch and response reading to the starting account.
export async function apiRequest(path,{method='GET',body,signal,anonymous=false,withoutToken=false,timeoutMs=30000,unavailable='This service is temporarily unavailable. Please try again.',cancelled='Request cancelled.'}={}){
  if(!path.startsWith('/api/'))throw new Error('Invalid account service address.');
  const user=auth.currentUser,uid=user?.uid||null;
  if(!user&&!anonymous)throw new Error('Sign in to continue.');
  const controller=new AbortController(),abort=()=>controller.abort();
  signal?.addEventListener('abort',abort,{once:true});
  if(signal?.aborted)abort();
  let timedOut=false;
  const timeout=setTimeout(()=>{timedOut=true;abort();},timeoutMs);
  const check=()=>{
    if(controller.signal.aborted)throw new Error(timedOut?'The connection timed out. Please try again.':cancelled);
    if((auth.currentUser?.uid||null)!==uid)throw new Error('Your signed-in account changed. Please start again.');
  };
  const wait=task=>new Promise((resolve,reject)=>{
    const interrupted=()=>{try{check();}catch(error){reject(error);}};
    controller.signal.addEventListener('abort',interrupted,{once:true});
    if(controller.signal.aborted)interrupted();
    Promise.resolve(task).then(resolve,reject).finally(()=>controller.signal.removeEventListener('abort',interrupted));
  });
  try{
    check();
    const token=user&&!withoutToken?await wait(user.getIdToken()):null;
    check();
    const response=await wait(fetch(path,{method,signal:controller.signal,headers:{...(token?{Authorization:`Bearer ${token}`}:{ }),...(body!==undefined?{'Content-Type':'application/json'}:{})},...(body!==undefined?{body:JSON.stringify(body)}:{})}));
    check();
    let result;
    try{result=await wait(response.json());}catch{check();throw new Error(unavailable);}
    check();
    if(!result||typeof result!=='object'||Array.isArray(result))throw new Error(unavailable);
    if(!response.ok)throw Object.assign(new Error(typeof result.error==='string'?result.error:unavailable),{status:response.status});
    return result;
  }catch(error){
    check();
    if(error instanceof TypeError)throw new Error('Could not connect. Check your connection and try again.');
    throw error;
  }finally{clearTimeout(timeout);signal?.removeEventListener('abort',abort);}
}
